import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { otherEndpointType, } from 'root/src/shared/descriptions/endpoints/lenses';
import { authenticationTypes, userGroups, } from 'root/src/shared/constants/auth';
const createGiveawayEntryPayloadSchema = {
    type: 'object',
    properties: {
        actionId: {
            type: 'string',
        },
        giveawayId: {
            type: 'string',
        },
    },
    required: ['actionId', 'giveawayId'],
};
export const createGiveawayEntry = {
    [giveawayEndpointIds.CREATE_GIVEAWAY_ENTRY]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.viewer,
        endpointType: otherEndpointType,
        payloadSchema: createGiveawayEntryPayloadSchema,
    },
};
